module.exports = __webpack_public_path__ + "img/boardPan.b70da990.jpg";